<template>
    <DefaultPanel :class="minimize? 'service-panel minimize' : 'service-panel'"  :minimize="minimize" title="Attività selezionata" :is-selected="selected">
        <template>
            <div class="row no-gutters">
                <div :class="minimize? 'col-12' : 'col-12 col-md-4'">
                    <small-carousel :images="images" :autoplay="false"/>
                </div>
                <div :class="minimize? 'col-12 minimize' : 'col-12 col-md-8 right'">
                    <div class="position-relative">
                        <div class="border-bottom pb-1 mb-1">
                            <h6 class="text-primary text-uppercase mb-0">{{valueC.categoria}}</h6>
                            <h4 class="mb-0" style="height: 25px; overflow: hidden">{{valueC.nome}}</h4>
                        </div>
                        <div class="border-bottom pb-1 mb-2">
                            <div v-if="valueC.ore">
                                <img src="../../../assets/images/svg/black/icone_durata.svg" height="12px"/>
                                <span>{{valueC.ore}}</span>
                            </div>
                            <div v-if="valueC.tipologia">
                                <div class="phone" v-if="valueC.telefono">
                                    <img src="../../../assets/images/svg/black/icone_phone.svg" height="12px"/>
                                    <b>{{valueC.tipologia}}</b>
                                </div>
                            </div>
                            <div v-if="valueC.descrizione" class="d-flex" :style="isTrasferimento ? 'height: 80px; overflow: hidden' : 'height: 40px; overflow: hidden'">
                                <img class="mt-1 mr-1" src="../../../assets/images/svg/black/icone_lingua.svg" height="12px"/>
                                <span class="mt-1 d-block font-italic" style="line-height: 12px">{{valueC.descrizione}}</span>
                            </div>
                        </div>
                        <div v-if="!isTrasferimento" :class="minimize? 'position-relative text-center' : 'position-relative d-flex justify-content-between'">
                            <div class="d-md-flex justify-content-between mb-1 pr-1">
                                <div class="pt-1">
                                    <div v-for="(item, index) in groupsSelected" :key="index" class="pb-2">
                                        <div class="pretty p-default p-curve d-block">
                                            <input type="checkbox" :name="'camera'+index" v-model="item.selected" class="pt-1" @click="onCameraSelected(item)"/>
                                            <div class="d-block state p-secondary-o text-uppercase" style="font-size: 0.7rem">
                                                <label>{{'Camera ' + (index+1)}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <DateSelect v-if="!isMobile" :dates="value.dates" :value="dateSelected" @input="date => {dateSelected = date; modified = true; trackTabAttivitaCambiaData()}"/>
                            </div>
                            <div class="d-md-flex justify-content-end" style="height: 30px">
                                <div class="d-md-flex">
                                    <div class="text-right" v-if="prezzoCamere">
                                        <h5 class="nowrap currency mb-0" style="line-height: 20px">+ {{formatMoney(prezzoCamere)}} &euro;</h5>
                                        <p style="line-height: 10px; font-size: 0.6rem">per le camere selezionate</p>
                                    </div>
                                    <div v-if="!isMobile">
                                        <h6 v-if="selected && !modified" class="py-2 px-1 text-primary">SELEZIONATO</h6>
                                        <button v-else :disabled="disabledAdd" class="px-2 py-1 btn btn-primary ml-2" @click="onAdd">
                                            {{selected ? 'modifica' : 'aggiungi'}}
                                        </button>
                                    </div>
                                </div>
                                <div v-if="!isMobile" class="icon-circle-border-blue ml-1">
                                    <a href="javascript:void(0)" @click="onDetail">
                                        <img src="../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                                    </a>
                                </div>
                                <div v-if="!isMobile && selected && !value.isObbligatorio" class="icon-circle-border-blue ml-1">
                                    <a href="javascript:void(0)" @click="onRemove">
                                        <img src="../../../assets/images/svg/blue/icone_cestino.svg" width="16px"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div :class="minimize? '' : 'd-flex justify-content-end'">
                                <div v-if="!value.isTrasferimentoFisso" :class="minimize? '' : 'd-flex justify-content-end'">
                                    <button v-if="showAggiungiAndata" class="px-2 py-1 btn btn-primary mx-1 nowrap" @click="onAggiungiAndata" >+ andata</button>
                                    <button v-else :disabled="value.isTrasferimentoFisso" class="px-2 py-1 btn btn-secondary mx-1" @click="onRemoveAndata" >
                                        <img src="../../../assets/images/svg/white/icone_cestino.svg" width="16px"/>
                                        andata
                                    </button>
                                    <button v-if="showAggiungiRitorno" class="px-2 py-1 btn btn-primary mx-1 nowrap" @click="onAggiungiRitorno" >+ ritorno</button>
                                    <button v-else :disabled="value.isTrasferimentoFisso" class="px-2 py-1 btn btn-secondary mx-1" @click="onRemoveRitorno" >
                                        <img src="../../../assets/images/svg/white/icone_cestino.svg" width="16px"/>
                                        ritorno
                                    </button>
                                </div>
                                <div class="icon-circle-border-blue ml-1" style="height: 30px">
                                    <a href="javascript:void(0)" @click="onDetail">
                                        <img src="../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div v-if="isMobile && !isTrasferimento" class="justify-content-between mt-2">
                            <DateSelect class="mb-2" :dates="value.dates" :value="dateSelected" @input="date => {dateSelected = date; modified = true; trackTabAttivitaCambiaData()}"/>
                            <div class="d-flex justify-content-between">
                                <h5 v-if="selected && !modified" class="py-2 px-1 text-primary" style="line-height: 6px">SELEZIONATO</h5>
                                <button v-else :disabled="disabledAdd" class="w-100 px-2 py-1 btn btn-primary" @click="onAdd">
                                    {{selected ? 'modifica' : 'aggiungi'}}
                                </button>
                                <div class="d-flex">
                                    <div class="icon-circle-border-blue ml-1">
                                        <a href="javascript:void(0)" @click="onDetail">
                                            <img src="../../../assets/images/svg/blue/icone_dettagli.svg" width="16px" height="16px"/>
                                        </a>
                                    </div>
                                    <div v-if="selected && !value.isObbligatorio" class="icon-circle-border-blue ml-1">
                                        <a href="javascript:void(0)" @click="onRemove">
                                            <img src="../../../assets/images/svg/blue/icone_cestino.svg" width="16px"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </DefaultPanel>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import DefaultPanel from '../../templates/DefaultPanel'
import { Carousel, Slide } from 'vue-carousel'
import CarouselOne from './CarouselOne'
import CustomDatePicker from './CustomDatePicker'
import {isSameDate, clone} from '../../../utils/helper'
import {smallDateFormatter, formatMoney} from '../../../utils/formatter'
import ModalServiceChangeDate from './modals/ModalServiceChangeDate'
import SmallCarousel from './SmallCarousel'
import DateSelect from './DateSelect'
import AnalyticEvents from '../../common/AnalyticEvents'
import MobileDetector from '../../common/MobileDetector'

export default {
  name: 'ServicePanel',
  mixins: [AnalyticEvents, MobileDetector],
  components: { DateSelect, SmallCarousel, ModalServiceChangeDate, CustomDatePicker, CarouselOne, Carousel, Slide, DefaultPanel },
  props: {
    openToDate: {
      type: Date
    },
    value: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Boolean,
      default: false
    },
    minimize: {
      type: Boolean,
      default: false
    },
    isTrasferimento: {
      type: Boolean,
      default: false
    },
    isFromModalMap: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    openToDate (newValue) {
      this.dateSelected = newValue
    },
    value (newValue) {
      this.groupsSelected = newValue.groups
    }
  },
  data: function () {
    return {
      modified: false,
      prezzoCamere: null,
      dateSelected: null,
      groupsSelected: null
    }
  },
  computed: {
    days () {
      return this.getItinerario().days
    },
    filter () {
      return this.isTrasferimento ? this.getTrasferimentiFilter() : this.getServiziFilter()
    },
    groupsSelectedCounter () {
      return this.groupsSelected.filter(item => item.selected).length
    },
    isAnagraficaLess () {
      return this.value.anagrafica === undefined
    },
    anagrafica () {
      return this.value.anagrafica
    },
    detail () {
      return this.value.anagrafica ? this.value.anagrafica.detailResponse.detail : this.value.detail
    },
    images () {
      return this.detail.imagesUrl
    },
    valueC: function () {
      const { detail } = this.value
      return {
        nome: detail.name,
        descrizione: detail.description,
        ore: detail.duration,
        categoria: detail.serviceType,
        tipologia: detail.line
      }
    },
    hasSelectCamera: function () {
      return this.groupsSelected.some(group => {
        return group.selected
      })
    },
    disabledAdd: function () {
      return this.dateSelected == null || (!this.isTrasferimento && !this.hasSelectCamera)
    },
    showAggiungiAndata () {
      const andata = this.getItinerario().trasferimenti.andata
      return andata === null || andata.detail.productID !== this.value.detail.productID
    },
    showAggiungiRitorno () {
      const ritorno = this.getItinerario().trasferimenti.ritorno
      return ritorno === null || ritorno.detail.productID !== this.value.detail.productID
    }
  },
  methods: {
    ...mapGetters(['getFlightFromLastDate', 'getSearch', 'getItinerario', 'getServiziFilter', 'getTrasferimentiFilter']),
    ...mapActions(['addReplaceServizio', 'removeSelectedServizio', 'removeSelectedServizioAll']),
    smallDateFormatter,
    formatMoney,
    prezzoCamereSelezionate () {
      let totale = 0
      this.groupsSelected.forEach(group => {
        if (group.selected) {
          const priceByDay = this.dateSelected ? this.value.pricesByDay.find(price => isSameDate(price.day, this.dateSelected)) : this.value.pricesByDay[0]
          const priceByGroup = priceByDay.prices.find(item => item.group === group.id)
          const priceFound = priceByGroup.prices[0]
          totale += priceFound.price.venditaTotaleEuro
        }
      })
      return Math.abs(totale)
    },
    onDetail () {
      this.isFromModalMap ? this.trackModaleListaAttivitaInfo() : this.trackTabAttivitaInfo()
      const payload = {...this.value, groups: [...this.groupsSelected]}
      this.$emit('detail', payload)
    },
    onCameraSelected (item) {
      item.selected = !item.selected
      this.modified = true
      this.prezzoCamere = null
      this.$nextTick(() => {
        this.prezzoCamere = this.prezzoCamereSelezionate()
      })
    },
    onAdd () {
      this.isFromModalMap ? this.trackModaleListaAttivitaAggiungi() : this.trackModaleAttivitaAggiungi()
      this.modified = false
      this.groupsSelected.forEach(item => { item.dateSelected = item.selected ? this.dateSelected : null })
      const payload = {...this.value, groups: [...this.groupsSelected]}
      this.addReplaceServizio(payload)
      this.$emit('select', payload)
    },
    onRemove () {
      if (!this.selected) return
      const payload = {...this.value, isTrasferimento: this.isTrasferimento}
      this.trackModaleListaAttivitaElimina()
      this.removeSelectedServizioAll(payload)
      this.$emit('remove', payload)
    },
    onAggiungiAndata () {
      this.trackModaleListaTrasferimentiAA()
      this.dateSelected = this.getFlightFromLastDate()
      this.onAddTrasferimento(true)
    },
    onRemoveAndata () {
      this.dateSelected = this.getFlightFromLastDate()
      this.onRemoveTrasferimento(true)
    },
    onAggiungiRitorno () {
      this.trackModaleListaTrasferimentiRR()
      this.dateSelected = this.days[this.days.length - 1].day
      this.onAddTrasferimento(false)
    },
    onRemoveRitorno () {
      this.dateSelected = this.days[this.days.length - 1].day
      this.onRemoveTrasferimento(false)
    },
    onAddTrasferimento (isAndata) {
      const groups = clone(this.groupsSelected)
      groups.forEach(item => { item.dateSelected = item.selected ? this.dateSelected : null })
      const payload = {...this.value, isAndata, groups, isTrasferimento: this.isTrasferimento}
      this.addReplaceServizio(payload)
      this.$emit('select', payload)
    },
    onRemoveTrasferimento (isAndata) {
      if (!this.selected) return
      const payload = {day: this.dateSelected, servizio: {...this.value, isAndata, isTrasferimento: this.isTrasferimento}}
      this.removeSelectedServizio(payload)
    }
  },
  created () {
    this.groupsSelected = [...this.value.groups]
    this.dateSelected = this.openToDate ? this.openToDate : this.value.dates[0]
    if (this.selected) {
      this.dateSelected = this.value.groups.find(item => item.selected).dateSelected
    }
    this.prezzoCamere = this.prezzoCamereSelezionate()
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/ServicePanel.vue